import React from 'react';
import { Chip } from '../ui/Chip';
import { RangeSlider } from '../ui/RangeSlider';
import { Switch } from '../ui/Switch';
import { eventTypes, genres, weekDays } from '../../data/options';
import { baht } from '../../utils/format';
import type { PerformerPrefs } from '../../types/marketplace';
interface PerformerPreferencesFormProps {
  value: PerformerPrefs;
  onChange: (value: PerformerPrefs) => void;
}
const toggle = <T,>(list: T[], item: T) => list.includes(item) ? list.filter(x => x !== item) : [...list, item];
export function PerformerPreferencesForm({
  value,
  onChange
}: PerformerPreferencesFormProps) {
  return <div className="space-y-6" data-id="element-614" data-mp="1j9weh7fej3t9">
      <div data-id="element-615" data-mp="1o25x02e6t1li">
        <p className="mb-3 text-[15px] font-bold" data-id="element-616" data-mp="1o1w7sh0yuygv">Genres you want to play</p>
        <div className="flex flex-wrap gap-2" data-id="element-617" data-mp="1o40l1pkr99tt">
          {genres.map(g => <Chip key={g} selected={value.genres.includes(g)} onClick={() => onChange({
          ...value,
          genres: toggle(value.genres, g)
        })} data-id="element-618" data-mp="qmibosp0ve18">
              {g}
            </Chip>)}
        </div>
      </div>
      <div data-id="element-619" data-mp="2lnjp3l3j6im1">
        <p className="mb-3 text-[15px] font-bold" data-id="element-620" data-mp="2lna286ds8rkk">Event types</p>
        <div className="flex flex-wrap gap-2" data-id="element-621" data-mp="2hkdlymbpt7js">
          {eventTypes.map(t => <Chip key={t} selected={value.eventTypes.includes(t)} onClick={() => onChange({
          ...value,
          eventTypes: toggle(value.eventTypes, t)
        })} data-id="element-622" data-mp="2cruabuwl8mhm">
              {t}
            </Chip>)}
        </div>
      </div>
      <div data-id="element-623" data-mp="22w92vh8r2u0h">
        <p className="mb-3 text-[15px] font-bold" data-id="element-624" data-mp="22sv047w6cisi">Days you’re free</p>
        <div className="flex flex-wrap gap-2" data-id="element-625" data-mp="1xv3ajkj058rh">
          {weekDays.map(d => <Chip key={d} selected={value.days.includes(d)} onClick={() => onChange({
          ...value,
          days: toggle(value.days, d)
        })} data-id="element-626" data-mp="1tvaw4r6xg8e7">
              {d}
            </Chip>)}
        </div>
      </div>
      <RangeSlider label="Minimum fee" min={2000} max={60000} step={500} value={value.minFee} onChange={minFee => onChange({
      ...value,
      minFee
    })} format={baht} data-id="element-627" data-mp="3o794ys1br29k" />
      <RangeSlider label="Max travel" min={5} max={250} step={5} value={value.maxTravelKm} onChange={maxTravelKm => onChange({
      ...value,
      maxTravelKm
    })} format={v => `${v} km`} data-id="element-628" data-mp="68g7z2gco706" />
      <Switch label="Open to multi-act line-ups" description="Show events booking several singers or bands" checked={value.multiActOk} onChange={multiActOk => onChange({
      ...value,
      multiActOk
    })} data-id="element-629" data-mp="3tefl9cxparbt" />
    </div>;
}